import { render, staticRenderFns } from "./CompanyUser.vue?vue&type=template&id=0dfe615c&scoped=true"
import script from "./CompanyUser.vue?vue&type=script&lang=js"
export * from "./CompanyUser.vue?vue&type=script&lang=js"
import style0 from "./CompanyUser.vue?vue&type=style&index=0&id=0dfe615c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe615c",
  null
  
)

export default component.exports